// @flow

import * as wjcGrid from 'wijmo/wijmo.grid';

import type { FormatterArgs } from '../types';

type FormatStyle = 'row' | 'cell';
type StatusFormatter = {
  columnName: string,
  formatStyle: FormatStyle,
  formatter: ({
    grid: any,
    elem: any,
    dataItem: any,
    args?: FormatterArgs,
  }) => mixed,
  args?: FormatterArgs,
};

const createColumnOrRowFormatter = ({
  columnName,
  formatStyle,
  formatter,
  args,
}: StatusFormatter) => (flex: any, e: any) => {
  if (
    e.panel.cellType === wjcGrid.CellType.Cell &&
    (formatStyle === 'row'
      ? true
      : e.panel.columns[e.col].binding === columnName)
  ) {
    const item = e.panel.rows[e.row].dataItem;

    formatter({
      grid: flex,
      elem: e,
      dataItem: item,
      args,
    });
  }
};

export { createColumnOrRowFormatter };
